import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { push } from 'react-router-redux'
import { notification } from 'antd'
import store from 'store'
import { login, logout, register, updateProfile } from 'services/user'
import actions from './actions'

const getCurrentUser = state => state.user

export function* LOGIN({ payload }) {
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(login, email, password)
  if (response) {
    notification.success({
      message: 'Entrada',
      description: 'Se ha ingresado correctamente a la plaraforma',
    })
    const { id, photoURL: avatar, name } = response
    yield store.set('app.user', response)
    yield put({
      type: actions.SET_STATE,
      payload: {
        id,
        name,
        nickname: response.nickname,
        firstname: response.firstname,
        lastname: response.lastname,
        email: response.email,
        mobile: response.mobile,
        avatar,
        token: response.token,
        suscription: response.suscription,
        kind: response.kind,
        authorized: true,
      },
    })
  }
  yield put({
    type: 'menu/GET_DATA',
  })
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* LOAD_CURRENT_ACCOUNT() {
  const currentUser = yield select(getCurrentUser)
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  //   const response = yield call(currentAccount, currentUser )
  if (currentUser) {
    const { id, email, photoURL: avatar, name, uid } = currentUser
    const auth = typeof name !== 'undefined'
    yield put({
      type: actions.SET_STATE,
      payload: {
        id,
        uid,
        name,
        nickname: currentUser.nickname,
        firstname: currentUser.firstname,
        lastname: currentUser.lastname,
        email,
        mobile: currentUser.mobile,
        avatar,
        token: currentUser.token,
        suscription: currentUser.suscription,
        kind: currentUser.kind,
        authorized: auth,
      },
    })
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
  yield put({ type: 'menu/GET_DATA' })
}

export function* LOGOUT() {
  yield call(logout)
  yield store.remove('app.user')
  yield put({
    type: actions.SET_STATE,
    payload: {
      id: null,
      name: null,
      nickname: null,
      firstname: null,
      lastname: null,
      email: null,
      mobile: null,
      avatar: null,
      kind: null,
      token: null,
      suscription: null,
      authorized: false,
      loading: false,
    },
  })
}

export function* REGISTER({ payload }) {
  const { email, password, invitation, subscript } = payload
  const result = yield call(register, email, password, invitation, subscript)
  if (result) {
    notification.success({
      message: 'Usuario creado',
      description: 'Revise su cuenta de correo para activar su suscripción',
    })

    yield put({
      type: actions.SET_STATE,
      payload: {
        id: '',
        name: '',
        role: '',
        email: '',
        avatar: '',
        loading: false,
      },
    })
    yield put(push('/user/login'))
  }
}

export function* UPDATE_PROFILE({ payload }) {
  const data = payload
  const currentUser = yield select(getCurrentUser)
  const response = yield call(updateProfile, data, currentUser.token)
  if (response) {
    notification.success({
      message: 'Perfil actualizado',
      description: 'Favor de entrar de nuevo al sistema para actualizar',
    })
    yield put({ type: 'user/LOGOUT' })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.UPDATE_PROFILE, UPDATE_PROFILE),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
